import React, { useEffect, useState, Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Query } from "@apollo/client/react/components";
import { bindActionCreators } from "redux";
import * as actions from "../../store/actions/actions";
import HeaderRun from "./Header.run";
import history from "../../utils/history";
import { menuOpciones } from "./menuOpciones";
import { GET_AUTH_INFO } from "../../graphql/queries/configuration";
import HeaderMenu from "./HeaderMenu";
class Header extends Component {
  
  state = {
    actionMenu: '1'
  };
  
  componentDidMount() {
    HeaderRun();
  }

  toggleCollapsed = (e) => {
    e.preventDefault();
    this.props.actions.toggleSetting("isCollapsed");
    this.resize();
  };

  toggleUserProfile = (e) => {
    e.preventDefault();
    this.props.actions.toggleDialog("userProfile");
  };

  resize() {
    const evt = document.createEvent("UIEvents");
    evt.initUIEvent("resize", true, false, window, 0);
    window.dispatchEvent(evt);
  }

  render() {
    return (
      <Query query={GET_AUTH_INFO}>
        {({ loading, data }) => {
          if (loading) {
            return null;
          }

          const { authInfo } = data.configuracion;

          if (!authInfo) {
            history.push("/login");
            return null;
          }

          return (
            <div className="head">
              <HeaderMenu items={menuOpciones} authInfo={authInfo}/>
            </div>
          );
        }}
      </Query>
    );
  }
}

Header.propTypes = {
  actions: PropTypes.object,
  settings: PropTypes.object,
  onClickBars: PropTypes.func,
};

const mapStateToProps = (state) => ({ settings: state.settings });
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
